import { css } from '@emotion/react';

import { colors } from 'src/styles/colors';
import { getInitialLoadIcons, ZeeFontRegular } from 'src/styles/font';
import { MediaBP as MQ } from 'src/styles/mediaQuery';
import { flex } from 'src/styles/utils';
import { InitialLoadIconsSet } from 'src/utils/constants/IconsConstants';

export const metaBtnIconStyle = css`
  ${flex('column', 'center', 'center')}
  font-size: 1.8rem;
  cursor: pointer;
  color: ${colors.white};

  ${MQ.MediaSm} {
    font-size: 2.4rem;
  }
`;

export const metaBtnTextStyle = css`
  color: ${colors.PrimaryWhiteColorAlpha50};
  margin-top: 10px;
  ${MQ.MediaSm} {
    ${ZeeFontRegular(16, 18)};
  }
`;

export const removeFromWatchlistStyle = css`
  ${getInitialLoadIcons(InitialLoadIconsSet.REMOVE_FROM_WATCHLIST)};
  color: ${colors.PurpleLight};
`;

export const promoButtonDiv = (shouldDisableTrailerEvent: boolean) => css`
  ${flex('column', 'space-evenly', '')};
  padding: 16px 48px;
  background: ${colors.PrimaryWhiteColorAlpha08};
  cursor: pointer;
  ${shouldDisableTrailerEvent
    ? `
    cursor: default;
    pointer-events: none;
  `
    : ``}
`;

export const playBtn = (shouldDisableTrailerEvent: boolean) => css`
  margin: 0 auto;
  width: 32px;
  height: 32px;
  line-height: 18px;
  position: relative;
  background: ${colors.PrimaryWhiteColor};
  border-radius: 50%;
  left: 0px;
  ${shouldDisableTrailerEvent ? `opacity: 0.5;` : ``}
`;

export const watchTrailerText = (shouldDisableTrailerEvent: boolean) => css`
  color: ${colors.PrimaryWhiteColorAlpha50};
  width: max-content;
  text-align: center;
  ${shouldDisableTrailerEvent ? `opacity: 0.2;` : ``}
`;

export const playBtnArrow = css`
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 8px solid ${colors.AppBgColor};
  content: '';
  width: 0;
  height: 0;
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  left: 2px;
  right: 0;
`;

export const watchlistContainer = css`
  display: flex;
  background: ${colors.PrimaryWhiteColorAlpha04};
`;

export const shareContainerCss = css`
  ${flex('row', '', '')};
  margin-top: 15px;
  width: 20%;
`;
